import { FC, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { FullPageError } from 'src/components/full-page-error/FullPageError';
import { Logger } from 'src/services/Logger';

import { handleSuccessfulAuthentication } from '../../helpers/AuthenticationHelper';
import { useUniversalLogin } from '../../hooks/useUniversalLogin';
import { useUserTenant } from '../../providers/userTenantProvider/UserTenantProvider';
import { getRedirectToPath } from '../../services/LoginRedirectionService';

import { AUTH_TOKEN_LABELS } from './AuthToken.labels';

export const AuthToken: FC = () => {
	const { getAccessToken } = useUniversalLogin();
	const history = useHistory();
	const { updateUserTenant } = useUserTenant();
	const [hasAuthenticationError, setHasAuthenticationError] = useState(false);

	const handleAuthentication = useCallback(async () => {
		try {
			setHasAuthenticationError(false);
			const accessToken = await getAccessToken();
			await handleSuccessfulAuthentication({ accessToken, idToken: accessToken, appState: null });
		} catch (e) {
			Logger.error('Failed to complete authentication callback', e);
			setHasAuthenticationError(true);
			return;
		}

		try {
			await updateUserTenant();
		} catch {
			return;
		}

		const { path } = getRedirectToPath();
		history.push(path);
	}, [getAccessToken, history, updateUserTenant]);

	useEffect(() => {
		handleAuthentication();
	}, [handleAuthentication]);

	if (hasAuthenticationError) {
		return <FullPageError title={AUTH_TOKEN_LABELS.authenticationErrorTitle} />;
	}

	return <EvSpinner />;
};
